import FormattedMessage from 'I18n/components/FormattedMessage';
import { useContext, useMemo } from 'react';
import { AppContext } from '../../../contexts/app/context';
import { PageLayoutPropsContext } from '../../../contexts/pageLayout/PropsContext';
import { jsx as _jsx } from "react/jsx-runtime";
function NavBarTitle() {
  const {
    recurringMeetings
  } = useContext(PageLayoutPropsContext);
  const {
    isInMeeting,
    isPastMeeting,
    appName
  } = useContext(AppContext);
  const isInLivePastMeeting = useMemo(() => !!isInMeeting && isPastMeeting, [isInMeeting, isPastMeeting]);
  const isInLiveMeeting = useMemo(() => !!isInMeeting && !isPastMeeting, [isInMeeting, isPastMeeting]);
  if (!recurringMeetings.length) return null;
  if (isInLivePastMeeting) return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "app.header.pastMeeting",
    "data-test-id": `${appName}-past-meeting-title`
  });
  if (isInLiveMeeting) return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "app.header.liveMeeting",
    "data-test-id": `${appName}-live-meeting-title`
  });
  return null;
}
export default NavBarTitle;